import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Button, Dialog, DialogTitle, DialogContent, Alert, TextCharLimit} from 'views/components';
import {MarkdownEditorWithAutosave, Translate, translate} from 'views/module';

import {nanoid} from 'nanoid';


const GenerateCustomUrl = (props) => {
  const [customDescription, setCustomDescription] = React.useState('');
  const [recommendationId, setRecommendationId] = React.useState(nanoid());
  const [isShowingError, setIsShowingError] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState(translate('caregiver.CaregiverDetail.Settings.ProfileUrl.EditDialog.ErrorMessageDefault'));

  const {
    isGeneratingCustomUrl,
    setIsGeneratingCustomUrl,
    baseUrl,
    customUrlRef,
    setIsShowingCustomUrl,
    caregiverRn,
    caregiverBackend,
  } = props;

  const saveString = `CUSTOM-URL-DESCRIPTION-${caregiverRn}`;

  const onGenerate = () => {
    const recommendationData = {
      recommendationId: recommendationId,
      recommendation: {
        blob: customDescription,
        editorType: 'MARKDOWN',
      },
    };
    setIsLoading(true);

    const onSuccess = () => {
      customUrlRef.current = `${baseUrl}?recommendation=${recommendationId}`;
      setIsLoading(false);
      setIsGeneratingCustomUrl(false);
      setIsShowingCustomUrl(true);
    };

    const onError = (error) => {
      setIsLoading(false);
      setErrorMsg(
              error.message === 'recommendation_id_taken' ?
              `${translate('caregiver.CaregiverDetail.Settings.ProfileUrl.GenerateCustom.ErrorMessageRecommendationIdTaken')}` :
             `${translate('caregiver.CaregiverDetail.Settings.ProfileUrl.GenerateCustom.ErrorMessageDefault')}`,
      );
      setIsShowingError(true);
    };
    caregiverBackend.recommendation.createRecommendation(recommendationData, onSuccess, onError);
  };

  const onCancel = () => {
    setIsGeneratingCustomUrl(false);
  };

  const onClose = () => {
    setIsGeneratingCustomUrl(false);
  };

  return (
    <Dialog onClose={onClose} open={isGeneratingCustomUrl}>
      <DialogTitle onClose={onClose}>
        <Translate expression='caregiver.CaregiverDetail.Settings.ProfileUrl.GenerateCustom.Title' />
      </DialogTitle>
      <DialogContent>
        <Box sx={{width: '100%'}}>
          <Stack spacing={2}>
            <Box>
              <MarkdownEditorWithAutosave
                value={customDescription}
                onChange={setCustomDescription}
                saveString={saveString}
                autoFocus />
            </Box>
            <Stack
              sx={{
                m: 1,
              }}
              spacing={1}
            >
              <TextCharLimit
                label={translate('caregiver.CaregiverDetail.Settings.ProfileUrl.GenerateCustom.RecommendationId')}
                value={recommendationId}
                onChange={setRecommendationId}
                charLimit={50}
                error={false}
              />
              {
                isShowingError &&
                          <Alert severity="error" onClose={() => setIsShowingError(false)}>
                            {errorMsg}
                          </Alert>
              }
            </Stack>
            <Box xs={12}>
              <Stack direction={'row'} spacing={1} justifyContent='space-between'>
                <Button variant='outlined' sx={{height: '42px'}} onClick={onCancel}>
                  <Translate expression='caregiver.CaregiverDetail.Settings.ProfileUrl.GenerateCustom.CancelLabel'/>
                </Button>
                <Button sx={{height: '42px'}} onClick={onGenerate} loading={isLoading}>
                  <Translate expression='caregiver.CaregiverDetail.Settings.ProfileUrl.GenerateCustom.GenerateLabel'/>
                </Button>
              </Stack>
            </Box>
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

GenerateCustomUrl.propTypes = {
  isGeneratingCustomUrl: PropTypes.bool.isRequired,
  setIsGeneratingCustomUrl: PropTypes.func.isRequired,
  baseUrl: PropTypes.string.isRequired,
  customUrlRef: PropTypes.object.isRequired,
  setIsShowingCustomUrl: PropTypes.func.isRequired,
  caregiverRn: PropTypes.string.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default (React.memo(GenerateCustomUrl));

